import React, { useState } from "react";
import {
  Button,
  Modal,
  Box,
  Input,
  Typography,
  Tooltip,
  Snackbar,
  Select,
  Option,
} from "@mui/joy";
import {
  East,
  Mail,
  Person,
  Phone,
  PlaylistAddCheckCircle,
} from "@mui/icons-material";
import axios from "axios";

const HeaderButton = () => {
  const [open, setOpen] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [eventName, setEventName] = useState("");

  const [formData, setFormData] = useState({
    phoneNumber: "",
    firstName: "",
    lastName: "",
    email: "",
    event: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleEventName = (value) => {
    setEventName(value);
    setFormData((prevState) => ({
      ...prevState,
      event: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      await axios.post(
        "https://services.leadconnectorhq.com/hooks/ThQ6LuzgQgXIWKUDsvmH/webhook-trigger/2bd32fbf-3227-4d0a-a7ec-3394da96c00d",
        formData
      );
      setOpen(false);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setOpenSnackBar(true);
    }
  };

  const isFormValid = formData.firstName && formData.phoneNumber;

  return (
    <div>
      <div>
        <Button
          onClick={() => setOpen(true)}
          variant="solid"
          sx={{
            bgcolor: "#E0AE73",
            transition: "background-color 0.3s ease",
            fontSize: "1.2rem",
            letterSpacing: ".2px",
            borderRadius: "2px",
            fontFamily: "Lato, sans-serif",
            "&:hover": {
              bgcolor: "#bd9260",
              transform: "scale(1.05)",
            },
            marginTop: { xs: "10px" },
          }}
        >
          SIGN UP TODAY
        </Button>
      </div>

      <Modal
        sx={{
          marginTop: { xs: "1rem", md: "2rem" },
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 3,
            backgroundColor: "#fff",
            borderRadius: 8,
            boxShadow: 0,
            width: "90%",
            maxWidth: { xs: 340, md: 600 },
            margin: "auto",
            maxHeight: "80vh",
            overflowY: "auto",
            border: "1px solid #ddd",
            transition: "box-shadow 0.3s ease",
            "&:hover": {
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            },
          }}
        >
          <Typography
            variant="h6"
            sx={{
              marginBottom: 3,
              fontSize: "1.4rem",
              fontWeight: 600,
              letterSpacing: ".5px",
              fontFamily: "Lato, sans-serif",
              textAlign: "center",
            }}
          >
            Let's get started
          </Typography>
          <Box sx={{ width: "70%" }}>
            <Typography
              variant="h6"
              sx={{
                marginBottom: 1,
                fontSize: "1.1rem",
                fontWeight: 600,
                letterSpacing: ".5px",
                fontFamily: "Lato, sans-serif",
                textAlign: "center",
              }}
            >
              Select event
            </Typography>
            <Box sx={{ marginBottom: "1rem" }}>
              <Select
                sx={{ width: "100%" }}
                onChange={(e, value) => handleEventName(value)}
                value={eventName}
                placeholder="Select your event"
              >
                <Option value="Forum of Knightsbridge Medicare Seminar">
                  Forum of Knightsbridge Medicare Seminar
                </Option>
                <Option value="Medicare Lunch and Learn">
                  Harrison on 5th Medicare Lunch and Learn
                </Option>
                <Option value="Stark Financial -Aging Matters Medicare Event">
                  Stark Financial -Aging Matters Medicare Event
                </Option>
              </Select>
            </Box>

            {eventName === "Forum of Knightsbridge Medicare Seminar" && (
              <Typography
                variant="h6"
                sx={{
                  marginBottom: 3,
                  fontSize: "1.1rem",
                  fontWeight: 600,
                  letterSpacing: ".5px",
                  fontFamily: "Lato, sans-serif",
                  textAlign: "center",
                }}
              >
                7pm Sept 30th
              </Typography>
            )}
            {eventName === "Medicare Lunch and Learn" && (
              <Typography
                variant="h6"
                sx={{
                  marginBottom: 3,
                  fontSize: "1.1rem",
                  fontWeight: 600,
                  letterSpacing: ".5px",
                  fontFamily: "Lato, sans-serif",
                  textAlign: "center",
                }}
              >
                October 1 at 11am
              </Typography>
            )}
            {eventName === "Stark Financial Client Appreciation Event" && (
              <Typography
                variant="h6"
                sx={{
                  marginBottom: 3,
                  fontSize: "1.1rem",
                  fontWeight: 600,
                  letterSpacing: ".5px",
                  fontFamily: "Lato, sans-serif",
                  textAlign: "center",
                }}
              >
                October 3rd at 5:30pm
              </Typography>
            )}
          </Box>

          <Box
            sx={{
              width: "100%",
              marginBottom: 2,
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            <Input
              required
              name="firstName"
              placeholder="First name *"
              startDecorator={<Person />}
              value={formData.firstName}
              onChange={handleChange}
              sx={{
                flex: 1,
                fontSize: "14px",
                borderRadius: 4,
              }}
            />
            <Input
              required
              name="lastName"
              placeholder="Last name *"
              startDecorator={<Person />}
              value={formData.lastName}
              onChange={handleChange}
              sx={{
                flex: 1,
                fontSize: "14px",
                borderRadius: 4,
              }}
            />
          </Box>

          <Box
            sx={{
              width: "100%",
              marginBottom: 2,
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            <Input
              name="email"
              placeholder="Email *"
              startDecorator={<Mail />}
              value={formData.email}
              onChange={handleChange}
              sx={{
                flex: 1,
                fontSize: "14px",
                borderRadius: 4,
              }}
            />
            <Input
              required
              name="phoneNumber"
              placeholder="Phone number *"
              type="tel"
              startDecorator={<Phone />}
              value={formData.phoneNumber}
              onChange={handleChange}
              sx={{
                flex: 1,
                fontSize: "14px",
                borderRadius: 4,
              }}
            />
          </Box>

          <Tooltip
            title={
              !isFormValid ? "Please fill out all required fields" : "Submit"
            }
          >
            <span>
              <Button
                endDecorator={
                  <East sx={{ fontSize: "1.2rem", marginTop: "2px" }} />
                }
                variant="contained"
                sx={{
                  marginTop: 3,
                  fontSize: "16px",
                  padding: "8px 24px",
                  fontFamily: "Lato, sans-serif",
                  borderRadius: 4,
                  backgroundColor: isFormValid ? "#218372" : "#d3d3d3",
                  color: "#fff",
                }}
                onClick={handleSubmit}
                disabled={!isFormValid}
              >
                Sign up
              </Button>
            </span>
          </Tooltip>
        </Box>
      </Modal>

      <Snackbar
        autoHideDuration={3000}
        size="lg"
        variant="soft"
        color="success"
        open={openSnackBar}
        onClose={() => setOpenSnackBar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        startDecorator={<PlaylistAddCheckCircle />}
      >
        Sign up successful!
      </Snackbar>
    </div>
  );
};

export default HeaderButton;
